import { adminRoutes, userRoutes } from '@/router'

const state = {
  permissionRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.permissionRoutes = routes
  }
}

const actions = {
  generateRoutes({ commit }, role) {
    return new Promise(resolve => {
      let accessedRoutes
      if (role === 'admin') {
        accessedRoutes = adminRoutes
      } else {
        accessedRoutes = userRoutes
      }
      commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    })
  },
  setRoutes({commit}, routes) {
    commit('SET_ROUTES', routes)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
